import React, { Fragment } from "react";
import { Card } from "react-bootstrap";

const RawDataPersist = () => {
  return (
    <Fragment>
      <Card className="shadow-none" style={{ height: "79vh" }}>
        <Card.Body>"In Progress"</Card.Body>
      </Card>
    </Fragment>
  );
};

export default RawDataPersist;
